import React from 'react';
import { useSelector } from 'react-redux';

import PerformanceTrendSkeleton from 'components/data-containers/PerformanceTrend/SkeletonLoader';

import { checkIsExternalUser } from 'redux/reducers/authentication';
import { EntityContext } from 'context/entityContext';
import getSalesTypeOptions from 'helpers/getSalesTypeOptions';

const OverallPerformanceTrendWMG = React.lazy(() =>
  import('components/data-containers/PerformanceTrend/OverallWMG')
);

const OverallPerformanceTrend3rdParty = React.lazy(() =>
  import('components/data-containers/PerformanceTrend/Overall3rdParty')
);

const Overall: React.FC = () => {
  const isExternalUser = useSelector(checkIsExternalUser);
  const ctx = React.useContext(EntityContext);
  const { entityType } = ctx;

  if (isExternalUser) {
    return (
      // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
      <div>
        <React.Suspense
          fallback={
            <PerformanceTrendSkeleton
              title="Overall Performance"
              splitChartCount={
                getSalesTypeOptions(true, entityType, true).length
              }
              showSplitLineCharts
              showPeriodDropdown
              isNarrowScreen
            />
          }
        >
          <OverallPerformanceTrend3rdParty />
        </React.Suspense>
      </div>
    );
  }

  return (
    // Note: Do not remove the next <div>. It avoids flexbox to double margins between generic components.
    <div>
      <React.Suspense
        fallback={
          <PerformanceTrendSkeleton
            title="Overall Performance"
            dropdownLabel="Album Equivalents"
            toggleOptions={[
              {
                value: 'album-equivalents',
                label: 'Album Equivalents',
                active: true,
              },
              {
                value: 'by-type',
                label: 'By Consumption Type',
                active: false,
              },
            ]}
            showPeriodDropdown
            isNarrowScreen
          />
        }
      >
        <OverallPerformanceTrendWMG />
      </React.Suspense>
    </div>
  );
};

export default Overall;
